"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportService = void 0;
var _report = require("../controllers/report.controller");
var ReportService = {
  report: {
    addReport: _report.config.report,
    updateReport: _report.config.report + "/update",
    list: _report.config.report + "/list",
    edit: _report.config.report + "/edit",
    read: _report.config.report,
    change: _report.config.report + "/edit/brand/change",
    submit: _report.config.report + "/submit",
    approve: _report.config.report + "/approve",
    delete: _report.config.report,
    filter: _report.config.report,
    buildList: _report.config.report + "/list/build",
    pause: _report.config.report + "/pause",
    play: _report.config.report + "/resume",
    downloadEmail: _report.config.report,
    restrict: _report.config.report + "/restricted",
    unrestrict: _report.config.report + "/unrestricted",
    locked: _report.config.report + "/bulk/lock",
    unlocked: _report.config.report + "/bulk/unlock",
    viewSnapshots: _report.config.report,
    viewEditorList: _report.config.report,
    viewConfig: _report.config.report,
    softDelete: _report.config.report + "/delete/soft",
    softDeleteList: _report.config.report + "/list/soft/deleted",
    softDeleteRestore: _report.config.report + "/delete/soft/restore"
  },
  reportBulk: {
    bulkSubmit: _report.config.reportBulk + "/submit",
    bulkDeleted: _report.config.reportBulk,
    bulkGoLive: _report.config.reportBulk,
    buildAdd: _report.config.reportBulk,
    bulkPlay: _report.config.reportBulk + "/resume",
    bulkPause: _report.config.reportBulk + "/pause",
    bulkAlertOn: _report.config.reportBulk + "/alert/on",
    bulkAlertOff: _report.config.reportBulk + "/alert/off",
    bulkRestrict: _report.config.reportBulk + "/restricted",
    bulkUnrestrict: _report.config.reportBulk + "/unrestricted",
    bulkApprove: _report.config.reportBulk + "/approve",
    bulkSoftDelete: _report.config.reportBulk + "/delete/soft",
    bulkSoftDeleteRestore: _report.config.reportBulk + "/delete/soft/restore"
  },
  reportEditor: {
    // api is not ready for belown kj
    editReport: _report.config.reportEditor,
    editRecord: _report.config.reportEditor,
    list: _report.config.reportEditor + "/list",
    editorLock: _report.config.reportEditor + "/lock",
    editorLockExist: _report.config.reportEditor + "/lock/not-exist",
    editorUnlock: _report.config.reportEditor + "/unlock"
  },
  reportEdit: {
    root: _report.config.reportEdit,
    gotoUpdate: _report.config.reportEdit + "/goto-update",
    changeBrand: _report.config.reportEdit + "/brand/change"
  },
  reportUpdate: {
    root: _report.config.reportUpdate,
    check: _report.config.reportUpdate + "/check",
    exist: _report.config.reportUpdate + "/exist",
    fund: _report.config.reportUpdate + "/fund"
  },
  reportRendering: {
    rendering: _report.config.report + "/render",
    tab: _report.config.report + "/render/update/tab",
    goToFund: _report.config.report + "/render/gotofund",
    reportLatest: _report.config.report + "/render/latest"
  }
};
exports.ReportService = ReportService;